import { Box,Typography } from "@mui/material"
import { colors } from "../Theme/tokens"

function IdleCashField({idleCash}) {
  return (
        <Box sx={{display:"flex",justifyContent:"space-between", minWidth:"250px",  maxWidth:"250px", p:"8px 16px",  backgroundColor:colors.background.cardDivBg, height:"fit-content", borderRadius:"8px"}}>
            <Typography
            sx={{
                color:colors.text.primary, fontWeight:"500", fontSize:{xs:"12px",lg:"14px"}
            }}
            >
            Idle Cash Available:  
            </Typography>
            <Typography
            sx={{
                color:colors.text.primary, fontWeight:"500", fontSize:{xs:"12px",lg:"14px"},fontWeight:"500"
            }}
            >
            $ {parseFloat(idleCash)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </Typography>
        </Box> 
  )
}

export default IdleCashField